import { ReportDetailsModule } from '@/components/modules/Reports/ReportDetails/ReportDetails';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_REPORT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.REPORT,
  schemesByRoles: [
    {
      roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.MERCHANT_GROUP, APP_ROLES.MERCHANT, APP_ROLES.PARTNER],
      titleTextId: 'REPORT',
      widgets: [
        {
          id: WIDGETS.PAYOUT_PAGE_TITLE,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'SUMMARY',
      module: (
        <ReportDetailsModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
            ],
          }}
        />
      ),
    },
  ],
};
